import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import React from 'react';
import { ItemActions, type ItemActionsProps } from '@europrocurement/flexy-components';
import DocumentIcon from '../DocumentIcon/DocumentIcon';
import { DocumentColor, DocumentIconType } from '../../../hooks';

export type DossierDocumentSignItemProps = {
    title: string;
    icon: DocumentIconType;
    color: DocumentColor;
    additionalInfos?: Array<string>;
    itemActions: ItemActionsProps;
};

const DossierDocumentSignItem: React.FunctionComponent<DossierDocumentSignItemProps> = function (
    props,
) {
    const { title, icon, color, additionalInfos = [], itemActions } = props;

    return (
        <Card
            key={title}
            variant="outlined"
            sx={{
                margin: 0,
                bgcolor: 'background.paper',
                border: 1,
                borderColor: 'divider',
            }}
        >
            <CardContent sx={{ paddingTop: 0, paddingBottom: '0px !important' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <DocumentIcon
                        color={color}
                        icon={icon}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5em',
                            alignItems: 'flex-start',
                            flexGrow: 1,
                        }}
                    >
                        <Typography
                            variant="l2dh7"
                            fontWeight="500"
                        >
                            {title}
                        </Typography>
                        {additionalInfos.length > 0 && (
                            <Box sx={{ display: 'flex', columnGap: '0.25em' }}>
                                {additionalInfos.map((item) => (
                                    <Chip
                                        key={item}
                                        label={item}
                                        color="default"
                                        size="small"
                                        sx={{
                                            mt: 0.5,
                                            backgroundColor: `default`,
                                            color: `text.gris35`,
                                            fontSize: '12px',
                                            fontWeight: '500',
                                        }}
                                    />
                                ))}
                            </Box>
                        )}
                    </Box>
                    <Box>
                        <ItemActions {...itemActions} />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default DossierDocumentSignItem;
